import { css } from 'styled-components';
import {
  ActionCardContainer,
  Body,
  HeadingContainer,
} from '../../../../components/ActionCard/ActionCard/styles';
import { colors } from '../../colors';
import { interactionStatesForCards } from '../../helpers/commonStyles';

export default css`
  &${ActionCardContainer} {
    ${interactionStatesForCards};
  }

  ${HeadingContainer} {
    color: ${colors.neutral01};
  }

  ${Body} {
    color: ${colors.neutral01};
  }
`;
